import * as palette from "../../palette";

export default function MenuDivider() {
  return (
    <li
      css={{
        marginRight: -12,
        marginLeft: -12,
        borderBottom: `solid 1px ${palette.catskillWhite}`,
      }}
    />
  );
}
